module.exports = __webpack_public_path__ + "assets/svg/Icons/32/dashboard-blue-5269ea.svg";